import React, {createContext, useState} from 'react'
import './App.css';
import {Route, Switch} from "react-router-dom";
import Login from "./login/Login";
import Game from "./game/Game";
import Error from "./error/Error";
import Register from "./register/Register";
import Lobby from "./lobby/Lobby";
import Terms from "./terms/Terms";
import Withdraw from "./withdraw/Withdraw";
import Deposit from "./deposit/Deposit";
import CustomToaster from "./base/toaster/CustomToaster";
import Profile from "./profile/Profile";
import Banner from "./base/banner/Banner";
import Dialog from "./base/dialog/Dialog";

export const Context = createContext({});

function App() {
    const areSoundsEnabled = () => {
        const item = localStorage.getItem("sounds");
        return !item || item === "true";
    }

    const toggleSounds = () => {
        const soundsEnabled = areSoundsEnabled();
        const newValue = !soundsEnabled;
        localStorage.setItem("sounds", newValue.toString());
        setContext({...context, soundsEnabled: newValue})
    }

    const defaultContext = {
        soundsEnabled: areSoundsEnabled(),
        toggleSounds,
    };

    const [context, setContext] = useState(defaultContext);
    const [dialogVisible, setDialogVisible] = useState(true);

    return (
        <Context.Provider value={context}>
            <div>
                <Banner/>
                <Switch>
                    <Route path="/" exact><Lobby/></Route>
                    <Route path="/login"><Login/></Route>
                    <Route path="/register"><Register/></Route>
                    <Route path="/profile"><Profile/></Route>
                    <Route path="/terms"><Terms/></Route>
                    <Route path="/lobby"><Lobby/></Route>
                    <Route path="/withdraw"><Withdraw/></Route>
                    <Route path="/deposit"><Deposit/></Route>
                    <Route path="/table/:tableId"><Game/></Route>
                    <Route component={Error}/>
                </Switch>
                <CustomToaster/>
                <Dialog
                    title={"The game is paused"}
                    subtitle={"Due to lack of a funding and low interest during the last months, the game has been paused. " +
                    "If you are interested in bringing the game back or have any collaboration proposals, feel free to email hi@iotapoker.app."}
                    visible={dialogVisible}
                    positiveText={'Ok'}
                    onPositiveClick={() => {
                        setDialogVisible(false);
                    }}/>
            </div>
        </Context.Provider>


    );
}

export default App;
